import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { isExpiringPolicy } from '@helpers/policy-eligibility.utils';

@Injectable({
  providedIn: 'root',
})
export class PolicyTooltipService implements OnDestroy {
  private isMobileSubject = new BehaviorSubject<boolean>(window.innerWidth < 768);
  readonly isMobile$ = this.isMobileSubject.asObservable();
  private resizeSub: Subscription;

  get isMobile(): boolean {
    return this.isMobileSubject.value;
  }

  constructor() {
    this.resizeSub = fromEvent(window, 'resize').subscribe(() =>
      this.isMobileSubject.next(window.innerWidth < 768)
    );
  }

  ngOnDestroy(): void {
    this.resizeSub?.unsubscribe();
  }

  getOutstandingBalanceTooltip(policy: any): string | null {
    if (!policy) return null;
    return isExpiringPolicy(policy)
      ? 'Represents the total premium for your upcoming policy renewal. Also includes any amount due for your current term.'
      : null;
  }

  getMinAmountDueTooltip(): string {
    return 'Payments above the minimum due are evenly applied to future installments.';
  }

  getPifTooltip(policy: any): string | null {
    if (!policy) return null;

    return policy.pifDiscountInfo?.pifEligible && !policy.pifDiscountInfo?.isPaidInFull
      ? 'To receive the Pay in Full Discount, you must pay both "Pay in Full and Save" amount and "Current Term Remaining Balance".'
      : null;
  }

  getPayPlanTooltip(): string {
    return "To change your payment plan, please contact our Customer Service team.";
  }
}
